import { configureStore } from '@reduxjs/toolkit'
import loaderReducer from '../components/loader/loaderSlice'
import { layoutReducer } from "./layoutSlice";
import { apiSlice } from '../api/apiSlice';
import { dataProductReducer } from './dataProductSlice';


export default configureStore({
  reducer: {
    loader: loaderReducer,
    layout: layoutReducer,
    dataProduct: dataProductReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(apiSlice.middleware),
})


